import { useEffect, useState } from "react"
import LabelService from "../../state/label/LabelService"
import { View } from "../../state/listing/generic-listing"
import { COLUMNS_WITH_LABEL_IDS, doesViewIncludeIds } from "../listing/generic-listing/utils"
import { SelectOption } from "../types"

export const useFetchLabels = (view: View, controller: AbortController) => {
    const [labelOptions, setLabelOptions] = useState<SelectOption<string>[]>()
    const [loadingLabelOptions, setLoadingLabelOptions] = useState<boolean>(false)

    useEffect(() => {
        const shouldFetchLabels = view && !labelOptions && doesViewIncludeIds(view, COLUMNS_WITH_LABEL_IDS)
    
        if (shouldFetchLabels) {
            setLoadingLabelOptions(true)

            new Promise<SelectOption<string>[]>((resolve, reject) => {
                LabelService.getLabelsAsSelectOptions().then(resolve)
                controller.signal.addEventListener("abort", () => reject(new Error("labels request aborted")))
            }).then(labelOptions => {
                setLabelOptions(labelOptions)
                setLoadingLabelOptions(false)
            }).catch(err => console.warn(err))
        }
    }, [view])

    return {
        labelOptions,
        loadingLabelOptions,
    }
}


// WEBPACK FOOTER //
// ./src/common/hooks/UseFetchLabels.tsx